<template>
  <se-popup
    :classes="'sm:w-[375px]'"
    :show-close="false"
  >
    <div class="flex flex-col items-center mt-56">
      <se-avatar-chat-option :id="chatInfo?.advisor?.id" :size="68" :name="chatInfo?.advisor?.name"
                             :src="chatInfo?.advisor?.avatar"/>
    </div>
    <div class="flex flex-col items-center my-16">
      <h2 class="font-bold text-h-l mb-1">3 Free minutes are up!</h2>
      <p class="text-b-s">Continue to paid session?</p>
    </div>
    <div class="bg-neutral-10 rounded-12 flex flex-col items-center justify-center py-12 px-16">
      <p class="text-b-xs text-neutral-60">Time available</p>
      <p class="text-h-m font-bold">{{ canChatDuration }} min</p>
    </div>
    <div class="flex flex-col items-center justify-center gap-24 mt-32">
      <se-button
        @click="unPauseChat"
        class="w-full"
        type="primary"
        :loading="unpausing"
      >
        Continue Paid Chat
      </se-button>
      <se-button
        @click="closeChat(true)"
        class="w-full !ml-0"
        type="tertiary"
        :loading="stopTimerLoading || unpausing"
      >
        End Session
      </se-button>
    </div>
    <p class="line-on-side text-neutral-60 text-center text-b-xs mx-2 !mt-40 !mb-40">
      <span>or</span>
    </p>
    <div>
      <se-button class="w-full" type="secondary" @click="tryAnotherAdvisor">Try another advisor
      </se-button>
      <p class="text-b-s text-neutral-60 mt-2 mb-16">
        You can still try out
        <span class="text-primary-100 font-bold">2 more advisors</span>
        with the first 3 minutes for free if you prefer not to continue chatting with this advisor.
      </p>
    </div>
  </se-popup>
</template>

<script setup lang="ts">
import {computed} from "vue";
import SePopup from "@/src/shared/ui-kit/popup/Popup.vue";
import SeAvatarChatOption from "@/src/shared/ui-kit/avatar-chat-option/AvatarChatOption.vue";
import SeButton from "@/src/shared/ui-kit/button/Button.vue";
import {useStartChatPopupsStore} from "@/src/store/startChatPopups";
import {storeToRefs} from "pinia";
import {chatStore} from "@/src/store/chat";
import {usersStore} from "@/src/store/users";
import {getGlobalProperties} from "@/src/shared/helpers/getGlobalProperties";

const {$router} = getGlobalProperties()

const chat = chatStore()
const {unpausing, stopTimerLoading, chatInfo} = storeToRefs(chat)
const {closeChat, unPauseChat} = chat

const userStore = usersStore()
const {currentUser, isUser, isAdmin} = storeToRefs(userStore)

const tryAnotherAdvisor = () => {
  closeChat(true)
  $router.push('/advisors/online')
}

const canChatDuration = computed(() => {
  return Math.floor(Number(currentUser.value.amount) /
    Math.max(userStore.calculateDiscountedFee(chatInfo.value?.per_minute_fee, chatInfo.value?.advisor), 0.01))
})
</script>

<script lang="ts">
export default {
  name: 'SeContinueToPaidChatPopup',
};
</script>

<style scoped lang="scss">

</style>